var PhoneLineBuilder = /** @class */ (function () {
    function PhoneLineBuilder() {
        this.line = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            phoneNumber: '+9999999999999',
            name: 'bob'
        };
    }
    PhoneLineBuilder.prototype.withPhoneNumber = function (phoneNumber) {
        this.line.phoneNumber = phoneNumber;
        return this;
    };
    PhoneLineBuilder.prototype.withId = function (id) {
        this.line.id = id;
        return this;
    };
    PhoneLineBuilder.prototype.withName = function (name) {
        this.line.name = name;
        return this;
    };
    PhoneLineBuilder.prototype.build = function () {
        return this.line;
    };
    return PhoneLineBuilder;
}());
export { PhoneLineBuilder };
//# sourceMappingURL=phone-line.js.map